<main class="flex flex-column align-items-center">
  <qa-contact-form/>
</main>

